const standardOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
  credentials: 'same-origin' as RequestCredentials,
}

interface Options {
  method: 'GET' | 'POST' | 'DELETE' | 'PATCH',
}

interface JsonAndResponse {
  json: any,
  response: Response,
}

const request = (endpoint: string, noJson: boolean, options: Options) =>
  fetch(endpoint, { ...standardOptions, ...options })
    .then((response) => {
      if (noJson && response.ok) {
        return { response, json: {} };
      }

      return response.json().then(json => ({ json, response }))
    })
    .then(({ json, response }: JsonAndResponse) => {
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    })

export const CALL_API = '__CALL_API__'

export default (store: any) => (next: any) => (action: any) => {
  const callApi = action[CALL_API]

  if (typeof callApi === 'undefined') {
    return next(action);
  }

  let { endpoint } = callApi;
  const { types, noJson, additional, options } = callApi;
  const { REQUEST, SUCCESS, FAILURE } = types;

  if (typeof endpoint === 'function') {
    endpoint = endpoint(store.getState())
  }

  const actionWith = (data: any) => {
    const finalAction = { ...action, ...data };
    delete finalAction[CALL_API];
    return finalAction;
  }

  next(actionWith({ type: REQUEST, ...additional }))

  return request(endpoint, noJson, options).then(
    (response: Response) => next(actionWith({
      ...additional,
      response,
      type: SUCCESS,
    })),
    (error: Error) => next(actionWith({
      ...additional,
      error,
      type: FAILURE,
    }))
  )
}
